import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getFlexiblePrecision, getFlexibleRange, getTaskColorClass } from './scheduleUtils';
import { getTaskScheduleLabel } from './taskScheduleLabel';
import { TimelineTaskModal } from './TimelineTaskModal';
import { sortPlannerTasks } from './taskListOrder';
import { PlannerTaskInfo } from './types';
import { useTimelineView } from './TimelineViewContext';

export const CalendarMonthTaskBar: React.FC<{ date: Date; tasks: PlannerTaskInfo[] }> = ({ date, tasks }) => {
    const { t, i18n } = useTranslation();
    const { onDeleteTask, onEditTask, onToggleComplete } = useTimelineView();
    const [selectedTask, setSelectedTask] = useState<PlannerTaskInfo | null>(null);
    const monthStart = new Date(date.getFullYear(), date.getMonth(), 1);
    const monthEnd = new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59, 999);
    const monthTasks = sortPlannerTasks(tasks.filter(({ task }) => {
        if (getFlexiblePrecision(task) !== 'month') return false;
        const { start, end } = getFlexibleRange(task);
        return start <= monthEnd && end >= monthStart;
    }));
    if (!monthTasks.length) return null;
    const visibleTasks = monthTasks.slice(0, 2);
    return <>
        <div className="calendar-month-task-bar" aria-label={t('dailyPlanner.allMonth')}>
            <span>{t('dailyPlanner.allMonth')}</span>
            {visibleTasks.map((taskInfo) => <button key={taskInfo.task.id} type="button"
                data-timeline-task-id={taskInfo.task.id}
                className={`${getTaskColorClass(taskInfo.task)} ${taskInfo.task.completed ? 'completed' : ''}`}
                onClick={() => setSelectedTask(taskInfo)}>{taskInfo.task.title}</button>)}
            {monthTasks.length > visibleTasks.length && <span>+{monthTasks.length - visibleTasks.length}</span>}
        </div>
        {selectedTask && <TimelineTaskModal task={selectedTask.task} collectionId={selectedTask.collectionId}
            timeLabel={getTaskScheduleLabel(
                selectedTask.task, i18n.language, date.getFullYear(), undefined, {
                    deadline: t('addTask.deadline'), startsAt: t('dailyPlanner.startsAt'),
                    startsIn: t('dailyPlanner.startsIn'), startsOn: t('dailyPlanner.startsOn'),
                }
            )}
            onClose={() => setSelectedTask(null)} onDelete={onDeleteTask} onEdit={onEditTask}
            onToggleComplete={onToggleComplete} />}
    </>;
};
